import {
  Person,
  PersonOutline,
  Settings,
  SettingsOutlined,
  Bookmarks,
  BookmarksOutlined,
  AccountBalanceWalletOutlined,
  AccountBalanceWallet,
  ShoppingBasket,
  ShoppingBasketOutlined,
  NotificationsNone,
  Notifications,
  Payment,
  PaymentOutlined,
} from "@material-ui/icons";

const tabs = [
  {
    name: "Profile",
    panel: 0,
    icon: <PersonOutline />,
    activeIcon: <Person />,
  },
  {
    name: "E-Books",
    panel: 1,
    icon: <BookmarksOutlined />,
    activeIcon: <Bookmarks />,
  },
  {
    name: "Earnings",
    panel: 3,
    icon: <AccountBalanceWalletOutlined />,
    activeIcon: <AccountBalanceWallet />,
  },
  {
    name: "KleverBooks",
    panel: 2,
    icon: <BookmarksOutlined />,
    activeIcon: <Bookmarks />,
  },
  {
    name: "Settings",
    panel: 4,
    icon: <SettingsOutlined />,
    activeIcon: <Settings />,
  },
  {
    name: "Orders",
    panel: 5,
    icon: <ShoppingBasketOutlined />,
    activeIcon: <ShoppingBasket />,
  },
  {
    name: "Notifications",
    panel: 6,
    icon: <NotificationsNone />,
    activeIcon: <Notifications />,
  },
  {
    name: "Change Payment Method",
    panel: 7,
    icon: <PaymentOutlined />,
    activeIcon: <Payment />,
  },
];

export default tabs;